import { render, staticRenderFns } from "./storeTrend.vue?vue&type=template&id=721751df&scoped=true"
import script from "./storeTrend.vue?vue&type=script&lang=js"
export * from "./storeTrend.vue?vue&type=script&lang=js"
import style0 from "./storeTrend.vue?vue&type=style&index=0&id=721751df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721751df",
  null
  
)

export default component.exports